import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getConversations = async ({params, config}) => get('/conversations', {params, ...config});
export const getConversation = async ({id, params, config}) => get(`/conversations/${id}`, {params, ...config});
export const createConversation = async ({body, config}) => post('/conversations', body, config);
export const updateConversation = async ({id, body, config}) => post(`/conversations/${id}`, body, config);
export const deleteConversation = async ({id, config}) => deleteRequest(`/conversations/${id}`, null, config);
export const getConversationMessages = async ({id, params, config}) => get(`/conversations/${id}/chat`, {params, ...config});
export const createConversationMessage = async ({id, body, config}) => post(`/conversations/${id}/chat`, body, config);

export const checkConversationAndCreateMessage = async ({id, body, config}) => {
    // Check if conversation exists
    let conversationId = id;
    if (!conversationId) {
        const conversationResponse = await createConversation({body, config});
        conversationId = conversationResponse._id;
    }

    // Create message in the conversation
    return await createConversationMessage({id: conversationId, body, config});
};